import { render } from "./JoinPublicationSignUp.vue.js?vue&type=template&id=867d6dfc&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=template&id=867d6dfc&scoped=true"
import script from "./JoinPublicationSignUp.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=script&lang=js"
export * from "./JoinPublicationSignUp.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=script&lang=js"

import "./JoinPublicationSignUp.vue.scss?vue&type=style&index=0&id=867d6dfc&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=style&index=0&id=867d6dfc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867d6dfc"],['__file',"src/Web/scripts/components/join-publication/JoinPublicationSignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "867d6dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('867d6dfc', __exports__)) {
    api.reload('867d6dfc', __exports__)
  }
  
  module.hot.accept("./JoinPublicationSignUp.vue.js?vue&type=template&id=867d6dfc&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=template&id=867d6dfc&scoped=true", () => {
    api.rerender('867d6dfc', render)
  })

}


export default __exports__